@import '~less/global-variables';
@import '~less/bootstrap/legacy-mixins';

/**
 * Edit offer
 */

@offer-map-height: 400px;
@offer-map-height-xs: 220px;

.offers-edit.offers-edit-host {
  .offer-host-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;

    h1 {
      margin: 0;
      font-size: 28px;
    }
  }

  @media (max-width: @screen-xs) {
    .offer-host-header {
      h1 {
        font-size: 22px;
      }

      button {
        font-size: @font-size-base;
        white-space: nowrap;
      }
    }

    .offer-tabs.nav-tabs {
      position: static;
      display: flex;
      margin: 0 0 20px;

      .nav-item {
        flex: 1;
        text-align: center;
      }
    }

    .offer-map,
    .offer-location-overlay {
      position: relative;
      top: auto;
      height: 320px;
    }

    .offer-location-overlay {
      position: absolute;
      top: 0;
    }
  }
}

.offer-tabs {
  @media (max-width: @screen-xs) {
    margin-top: @navbar-height;
  }
  &.nav-tabs {
    @media (max-width: @screen-xs) {
      position: fixed;
      z-index: @zindex-navbar-fixed;
      top: @navbar-height;
      left: 0;
      right: 0;
      margin: 0;
    }
    @media (min-width: @screen-sm-min) {
      margin-bottom: 30px;
    }
    border: 0;
    background-color: #fff;
    .nav-item {
      @media (min-width: @screen-sm-min) {
        font-size: @font-size-large;
      }
      .nav-link {
        border: 0;
      }
      .nav-link.active {
        color: #fff;
        background-color: @gray-light;
        border: 0;
      }
    }
  }
}

.offers-edit {
  @media (max-width: @screen-xs) {
    // At footer we'll place fixed navigation,
    // ensure we have space for it
    margin-bottom: @navbar-height;

    form > .text-center {
      position: fixed;
      z-index: @zindex-popover + 1;
      right: 0;
      bottom: 0;
      left: 0;
      padding: 10px;
      background: #fff;
    }
  }
  .offer-map {
    position: relative;
    height: @offer-map-height;
  }
  #offer-add-location-canvas {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }
  // Overlay for the map consisting vignetting shadow and the central marker
  .offer-location-overlay {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    // Same as `.leaflet-marker-pane  { z-index: 600; }` at:
    // @link https://github.com/Leaflet/Leaflet/blob/master/dist/leaflet.css#L93
    z-index: 600;
    // Vignetting shadow, darker from sides and bright from the middle:
    box-shadow: inset 0 0 (@offer-map-height * 0.45) rgba(0, 0, 0, 0.45);
    // Allows dragging the map trough element:
    pointer-events: none;
    // Position icon to half the container minus distance to the icon's pointer
    // 38px = marker's heigh
    background-position-y: calc(~'50% - ' (38px / 2));
    background-position-x: 50%;
    background-repeat: no-repeat;
    .img-retina('~img/map/marker-locator.png', '~img/map/marker-locator@2x.png', 56px, 41px);
    &.offer-hosting-yes {
      .img-retina('~img/map/marker-locator-yes.png', '~img/map/marker-locator-yes@2x.png', 56px, 41px);
    }
    &.offer-hosting-maybe {
      .img-retina('~img/map/marker-locator-maybe.png', '~img/map/marker-locator-maybe@2x.png', 56px, 41px);
    }
  }
  // Mobile improvements on above elements
  @media (max-width: @screen-xs) {
    .offer-map,
    .offer-location-overlay {
      position: fixed;
      top: (@navbar-height + @navbar-height - 4px);
      left: 0;
      right: 0;
      height: @offer-map-height-xs; // fallback for browsers without support for calc()
      height: calc(
        ~'100% - ' (@navbar-height + @navbar-height + @navbar-height)
      );
    }
    .offer-meet-actions {
      position: fixed;
      z-index: @zindex-navbar-fixed + 1;
      right: 0;
      bottom: 0;
      left: 0;
      min-height: @navbar-height;
      background: #fff;
    }
    .offer-map-location-search {
      position: fixed;
      top: (@navbar-height + @navbar-height + 4px);
      z-index: @zindex-navbar-fixed + 1;
      left: 60px;
      right: 10px;
      width: auto;
      // Search input icon (magnifying class)
      .form-control-feedback {
        left: 11px;
        margin-top: 5px;
      }
      input#search-query {
        border: 0;
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.35);
        transition:
          background-color 200ms,
          width 200ms;
        background-color: rgba(255, 255, 255, 0.95);
        width: 46px;
        color: transparent;
        &:focus,
        &:active {
          padding-left: 46px; // makes space for the icon
          color: @text-color;
          background-color: rgba(255, 255, 255, 1);
          width: 100%;
        }
      }
    }
  }
  .offer-panel-map {
    position: relative;
  }
  .offer-map-guide {
    position: absolute;
    top: 0;
    z-index: @zindex-popover;
    left: 0;
    right: 0;
  }
  .offer-map-location-search {
    margin-bottom: 0;
  }
  .offer-nodescription,
  .offer-description {
    font-size: @font-size-large;
  }
  .btn-group > .btn-offer-hosting {
    &,
    &:hover {
      border-color: transparent;
    }
    span {
      border-bottom: 2px solid transparent;
      padding: 1px 2px;
      margin: 0 5px;
    }
    &.active {
      span {
        border-color: #fff;
      }
    }
  }
}

.offer-meta {
  @media (max-width: @screen-xs) {
    text-align: center;
  }
}

.offer-maxguests {
  @media (max-width: @screen-xs) {
    margin-top: 40px;
  }
}

.offers-edit {
  .btn-inverse-primary {
    margin-left: 5px;
  }
}
